/* APEXFLOW cart actions. Drawer markup: snippets/apex-cart.liquid. Product page picker:
   snippets/apex-bundle.liquid + assets/apex-bundle.js (uses window.apexCart below).

   Packages are VARIANTS (1 / 3 / 5 bottles) of the APEXFLOW product; the free gifts are
   the $0 "Free gift" variants of the gift products. Subscriptions are
   Loop selling plans on the same variants. Config comes from #apex-cart-config:
     { "products": { "<pid>": { "tiers": { "1": { "variant": id, "plan": id, "gifts": [variantIds] }, ... } } } }
   Moving between tiers swaps the variant: gifts the new tier adds go in first, the new
   bottles line is added, then the old line and dropped gifts are removed one by one, so
   tracking sees one product_added_to_cart and one product_removed_from_cart per change.
   Switching subscription on/off changes the line IN PLACE (selling_plan on cart/change.js).

   Subscribed 2+1 / 3+2 are split so refills only ship the paid bottles: a tier with a "sub"
   entry in the config is added as "1 Bottle" x2 / x3 on its own selling plan plus a one-time
   bonus bottle line (made free by an automatic discount). Moving into or out of a split tier
   rebuilds the lines (moveLine) instead of changing them in place. */
(function () {
  if (window.apexCart) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function config() {
    var el = document.getElementById('apex-cart-config');
    try {
      var c = el ? JSON.parse(el.textContent) : null;
      if (c && c.products) {
        delete c.products._;
        Object.keys(c.products).forEach(function (k) { if (c.products[k] && c.products[k].tiers) delete c.products[k].tiers._; });
      }
      return c;
    } catch (e) { return null; }
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function series(steps) {
    return steps.reduce(function (p, fn) { return p.then(fn); }, Promise.resolve());
  }

  function refresh() {
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var parser = new DOMParser();
        if (s['cart-drawer']) {
          var doc = parser.parseFromString(s['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('#CartDrawer'), cur = document.querySelector('#CartDrawer');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          var drawer = document.querySelector('cart-drawer'), freshDrawer = doc.querySelector('cart-drawer');
          if (drawer && freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var b = parser.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          bubble.innerHTML = b ? b.innerHTML : s['cart-icon-bubble'];
        }
        document.dispatchEvent(new CustomEvent('apex:cart-updated'));
      });
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') d.open();
  }

  function findKey(cart, key) {
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].key === key) return cart.items[i];
    return null;
  }

  function productCfg(pid) {
    var cfg = config();
    return cfg && cfg.products && cfg.products[String(pid)];
  }

  function tierOf(pc, variantId) {
    if (!pc) return null;
    var keys = Object.keys(pc.tiers);
    for (var i = 0; i < keys.length; i++) if (pc.tiers[keys[i]].variant === variantId) return Number(keys[i]);
    return null;
  }

  function planOf(line) {
    return line.selling_plan_allocation ? line.selling_plan_allocation.selling_plan.id : null;
  }

  /* Tier of a cart line: split subscription lines are matched by their plan first. */
  function tierOfLine(pc, line) {
    if (!pc) return null;
    var plan = planOf(line);
    var keys = Object.keys(pc.tiers);
    for (var i = 0; i < keys.length; i++) {
      var s = pc.tiers[keys[i]].sub;
      if (s && plan && s.plan === plan && s.variant === line.variant_id) return Number(keys[i]);
    }
    return tierOf(pc, line.variant_id);
  }

  function isSplit(pc, line) {
    var q = tierOfLine(pc, line);
    var s = q && pc.tiers[String(q)].sub;
    return !!(s && planOf(line) === s.plan);
  }

  function allBonusVariants(pc) {
    var out = [];
    Object.keys(pc.tiers).forEach(function (k) { var s = pc.tiers[k].sub; if (s && out.indexOf(s.bonus) < 0) out.push(s.bonus); });
    return out;
  }

  function bonusLines(cart, pc) {
    var b = allBonusVariants(pc);
    return cart.items.filter(function (i) { return b.indexOf(i.variant_id) >= 0; });
  }

  /* Rebuild one bottles line as tier q, subscribed or not, when a split tier is involved.
     The old bottles line comes out first, while its key is still valid (removing the bonus
     line drops the bonus discount, which changes the bottles line key), then the bonus lines
     (by variant), then the gifts the tier adds plus the new bottles (+ bonus) lines go in, and
     dropped gifts go. */
  function moveLine(lineKey, pid, q, wantPlan) {
    return getCart().then(function (cart) {
      var main = findKey(cart, lineKey);
      if (!main) return;
      var pc = productCfg(pid || main.product_id);
      var tier = pc && pc.tiers[String(q)];
      if (!tier) return;
      var items = [];
      if (wantPlan && tier.sub) {
        items.push({ id: tier.sub.variant, quantity: tier.sub.qty, selling_plan: tier.sub.plan });
        items.push({ id: tier.sub.bonus, quantity: tier.sub.bonusQty });
      } else {
        var item = { id: tier.variant, quantity: 1 };
        if (wantPlan && tier.plan) item.selling_plan = tier.plan;
        items.push(item);
      }
      var have = giftLines(cart, pc).map(function (i) { return i.variant_id; });
      var missing = tier.gifts.filter(function (v) { return have.indexOf(v) < 0; });
      var steps = [function () { return post('cart/change.js', { id: lineKey, quantity: 0 }); }];
      bonusLines(cart, pc).forEach(function (b) { steps.push(function () { return removeByVariant(b.variant_id, pc); }); });
      steps.push(function () {
        return post('cart/add.js', { items: missing.map(function (v) { return { id: v, quantity: 1 }; }).concat(items) });
      });
      have.filter(function (v) { return tier.gifts.indexOf(v) < 0; }).forEach(function (v) {
        steps.push(function () { return removeByVariant(v, pc); });
      });
      return series(steps);
    });
  }

  function allGiftVariants(pc) {
    var out = [];
    Object.keys(pc.tiers).forEach(function (k) { pc.tiers[k].gifts.forEach(function (v) { if (out.indexOf(v) < 0) out.push(v); }); });
    return out;
  }

  /* free gift lines currently in the cart (gift variant, $0) */
  function giftLines(cart, pc) {
    var g = allGiftVariants(pc);
    return cart.items.filter(function (i) { return g.indexOf(i.variant_id) >= 0; });
  }

  function removeByVariant(variantId, pc) {
    return getCart().then(function (c) {
      var cur = c.items.filter(function (x) { return x.variant_id === variantId; })[0];
      return cur ? post('cart/change.js', { id: cur.key, quantity: 0 }) : null;
    });
  }

  /* Move one bottles line (by cart key) to tier q. Keeps its subscription. */
  function setTier(lineKey, pid, q) {
    return getCart().then(function (cart) {
      var main = findKey(cart, lineKey);
      if (!main) return;
      var pc = productCfg(pid || main.product_id);
      var tier = pc && pc.tiers[String(q)];
      if (!tier) return post('cart/change.js', { id: lineKey, quantity: q });
      var subbed = !!main.selling_plan_allocation;
      if ((subbed && tier.sub) || isSplit(pc, main)) return moveLine(lineKey, pid, q, subbed);
      var plan = subbed ? tier.plan : null;
      var have = giftLines(cart, pc).map(function (i) { return i.variant_id; });
      var steps = [];
      var missing = tier.gifts.filter(function (v) { return have.indexOf(v) < 0; });
      if (missing.length) steps.push(function () { return post('cart/add.js', { items: missing.map(function (v) { return { id: v, quantity: 1 }; }) }); });
      var item = { id: tier.variant, quantity: 1 };
      if (plan) item.selling_plan = plan;
      steps.push(function () { return post('cart/add.js', { items: [item] }); });
      steps.push(function () { return post('cart/change.js', { id: lineKey, quantity: 0 }); });
      have.filter(function (v) { return tier.gifts.indexOf(v) < 0; }).forEach(function (v) {
        steps.push(function () { return removeByVariant(v, pc); });
      });
      return series(steps);
    });
  }

  /* Subscription on/off for a bottles line, in place. */
  function setPlan(lineKey, pid, on) {
    return getCart().then(function (cart) {
      var main = findKey(cart, lineKey);
      if (!main) return;
      var pc = productCfg(pid || main.product_id);
      var q = tierOfLine(pc, main);
      var tier = pc && q && pc.tiers[String(q)];
      if (tier && ((on && tier.sub) || isSplit(pc, main))) return moveLine(lineKey, pid, q, on);
      var body = { id: lineKey, quantity: main.quantity, selling_plan: on && tier && tier.plan ? tier.plan : null };
      return post('cart/change.js', body);
    });
  }

  /* Remove a bottles line and its gifts, one line at a time (fires removed events). */
  function removeLine(lineKey) {
    return getCart().then(function (cart) {
      var main = findKey(cart, lineKey);
      if (!main) return;
      var pc = productCfg(main.product_id);
      var steps = [function () { return post('cart/change.js', { id: lineKey, quantity: 0 }); }];
      if (pc) {
        if (isSplit(pc, main)) bonusLines(cart, pc).forEach(function (b) { steps.push(function () { return removeByVariant(b.variant_id, pc); }); });
        var others = cart.items.filter(function (i) { return i.key !== lineKey && productCfg(i.product_id); });
        if (!others.length) giftLines(cart, pc).forEach(function (g) { steps.push(function () { return removeByVariant(g.variant_id, pc); }); });
      }
      return series(steps);
    });
  }

  /* Product page: put tier q of this product in the cart (with selling plan `plan` or one-time).
     If the product is already in the cart, that line is moved to tier q instead. */
  function addBundle(pid, q, plan) {
    var pc = productCfg(pid);
    return getCart().then(function (cart) {
      var existing = cart.items.filter(function (i) { return i.product_id === Number(pid); })[0];
      if (existing && pc) {
        var same = tierOfLine(pc, existing) === Number(q);
        var wantPlan = !!plan;
        var hasPlan = !!existing.selling_plan_allocation;
        var target = pc.tiers[String(q)];
        if (!(same && wantPlan === hasPlan) && target && ((wantPlan && target.sub) || isSplit(pc, existing))) {
          return moveLine(existing.key, pid, q, wantPlan);
        }
        var steps = [];
        if (!same) steps.push(function () { return setTier(existing.key, pid, q); });
        if (wantPlan !== hasPlan) steps.push(function () {
          return getCart().then(function (c) {
            var line = c.items.filter(function (i) { return i.product_id === Number(pid); })[0];
            return line ? setPlan(line.key, pid, wantPlan) : null;
          });
        });
        return series(steps);
      }
      var tier = pc && pc.tiers[String(q)];
      if (!tier) throw new Error('Package not available');
      var items = tier.gifts.map(function (v) { return { id: v, quantity: 1 }; });
      if (plan && tier.sub) {
        items.push({ id: tier.sub.variant, quantity: tier.sub.qty, selling_plan: tier.sub.plan });
        items.push({ id: tier.sub.bonus, quantity: tier.sub.bonusQty });
        return post('cart/add.js', { items: items });
      }
      var item = { id: tier.variant, quantity: 1 };
      if (plan) item.selling_plan = plan;
      items.push(item);
      return post('cart/add.js', { items: items });
    });
  }

  window.apexCart = { addBundle: addBundle, setTier: setTier, setPlan: setPlan, removeLine: removeLine, refresh: refresh, openDrawer: openDrawer };

  /* ---------- drawer controls ---------- */
  function step(row, dir) {
    var q = parseInt(row.getAttribute('data-qty'), 10) || 1;
    var key = row.getAttribute('data-key'), pid = row.getAttribute('data-pid');
    if (row.getAttribute('data-tiered') !== 'true') return post('cart/change.js', { id: key, quantity: Math.max(1, q + dir) });
    var tiers = [1, 3, 5];
    var next = null;
    if (dir > 0) { for (var i = 0; i < tiers.length; i++) if (tiers[i] > q) { next = tiers[i]; break; } }
    else { for (var j = tiers.length - 1; j >= 0; j--) if (tiers[j] < q) { next = tiers[j]; break; } }
    if (next === null) return Promise.resolve();
    return setTier(key, pid, next);
  }

  function run(el, job) {
    var box = el.closest('[data-apx-cart-root]');
    if (box) { if (box.classList.contains('apx-busy')) return; box.classList.add('apx-busy'); }
    job().then(refresh).catch(function (err) {
      return refresh().then(function () {
        var e = document.querySelector('[data-apx-error]');
        if (e) { e.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; e.hidden = false; }
      });
    });
  }

  document.addEventListener('toggle', function (ev) {
    var d = ev.target;
    if (!d.classList || !d.classList.contains('apx-inc') || !d.open) return;
    var body = d.closest('.cart-drawer__body');
    if (body) body.scrollTo({ top: body.scrollHeight, behavior: 'smooth' });
  }, true);

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var s = t.closest('[data-apx-step]');
    if (s) { ev.preventDefault(); if (s.disabled) return; var r = s.closest('[data-apx-line]'); run(s, function () { return step(r, parseInt(s.getAttribute('data-apx-step'), 10)); }); return; }
    var d = t.closest('[data-apx-remove]');
    if (d) { ev.preventDefault(); var r2 = d.closest('[data-apx-line]'); run(d, function () { return removeLine(r2.getAttribute('data-key')); }); return; }
    var p = t.closest('[data-apx-plan]');
    if (p) { ev.preventDefault(); var r4 = p.closest('[data-apx-line]'); run(p, function () { return setPlan(r4.getAttribute('data-key'), r4.getAttribute('data-pid'), p.getAttribute('data-apx-plan') === 'on'); }); return; }
    var u = t.closest('[data-apx-upgrade]');
    if (u) {
      ev.preventDefault();
      var r3 = document.querySelector('[data-apx-line][data-key="' + u.getAttribute('data-key') + '"]');
      if (r3) run(u, function () { return setTier(r3.getAttribute('data-key'), r3.getAttribute('data-pid'), 3); });
    }
  });
})();
